import { instance } from '@/services/avik-api-gateway'
import { AxiosResponse } from 'axios'

export function deleteProject(): Promise<AxiosResponse<unknown>> {
  return instance.delete(`/iam/project`)
}
